import { Box, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import CheckListModelTaskComponent from "../CheckListModelTasks/CheckListModelTaskComponent";
import CheckListModelEquipmentComponent from "./CheckListModelEquipmentComponent";

type CheckListModelNavBarType = {
    childrenColumnSize?: number;
};

export function CheckListModelNavBar({ childrenColumnSize = 12 }: CheckListModelNavBarType) {
    const intl = useIntl();
    const [activeTab, setActiveTab] = useState<number>(0);
    const { id } = useParams<{ id: string }>();

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };


    return (
        <Box sx={{ width: "100%" }}>
            {/* Navbar com linha */}
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                    value={activeTab}
                    onChange={handleChange}
                    aria-label="CheckList Tasks Tab"
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                >
                    <Tab label={intl.formatMessage({ id: "Screens.CheckList.Navbar.Tasks" })} {...a11yProps(0)} />
                    <Tab label={intl.formatMessage({ id: "Screens.CheckList.Navbar.Equipments", defaultMessage: "Equipamentos" })} {...a11yProps(1)} />
                </Tabs>
            </Box>

            {/* Conteúdo alinhado exatamente abaixo */}
            <Box mt={2}>  {/* margem opcional para separar da linha */}
                <TabPanel value={activeTab} index={0} childrenColumnSize={childrenColumnSize}>
                    <CheckListModelTaskComponent checkListModelId={id ?? null} />
                </TabPanel>
                <TabPanel value={activeTab} index={1} childrenColumnSize={childrenColumnSize}>
                    <CheckListModelEquipmentComponent checkListModelId={id ?? null} />
                </TabPanel>
            </Box>
        </Box>
    );
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    childrenColumnSize: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}